<bi-app id="biApp" [pageDefinition]="pageDefinition" [baseUrl]="baseURL" *ngIf="sharedService.dashboardSessionStored()"></bi-app>